export const defaultPagingObject = {
  totalCount: 0,
  currentPageNo: 1,
};

export const defaultPagingListObject = {
  list: [],
  pagination: defaultPagingObject,
};
